import React from 'react';
import { Box, Typography } from '@mui/material';
import { DOCUMENT_GENERATION, CALL_CAMPAIGN } from '../../constants/constants';
import { ManageTemplatesProps } from '../../interfaces/tcnTemplate';
import ManageDocumentTemplate from './manageTemplates/manageDocumentTemplate';
import ManageDialerTemplate from './manageTemplates/manageDialerTemplate';


const ManageTemplates: React.FC<ManageTemplatesProps> = ({ campaignType }) => {
  if (campaignType === DOCUMENT_GENERATION) {
    return <ManageDocumentTemplate />;
  }

  if (campaignType === CALL_CAMPAIGN) {
    return <ManageDialerTemplate />;
  }

  // Fallback for unknown campaign types
  return (
    <Box sx={{ ml: 2, mr: 2 }}>
      <Box display="flex" justifyContent="center" alignItems="center" py={4}>
        <Typography variant="h6" color="text.secondary">
          Template management not available for this campaign type
        </Typography>
      </Box>
    </Box>
  );
};

export default ManageTemplates;